module.exports = __webpack_public_path__ + "static/media/support-dogs.9fce529d.png";